import React, { FC, SVGProps } from 'react';

export const Xmark: FC<SVGProps<SVGSVGElement>> = ({ fill, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1.63684"
      y="0.222656"
      width="20"
      height="2"
      rx="1"
      transform="rotate(45 1.63684 0.222656)"
      fill={fill || 'white'}
    />
    <rect
      x="0.222656"
      y="14.3647"
      width="20"
      height="2"
      rx="1"
      transform="rotate(-45 0.222656 14.3647)"
      fill={fill || 'white'}
    />
  </svg>
);
